import { render } from "./SolutionDetailSSO.vue?vue&type=template&id=544195e3"
import script from "./SolutionDetailSSO.vue?vue&type=script&lang=js"
export * from "./SolutionDetailSSO.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__